import * as StatusBarActions from "../actions/Status.Actions";

export interface IStatus {
  isConnected: boolean;
}

const initialState: IStatus = {
  isConnected: false,
};

export const StatusBarReducer = (state: IStatus = initialState, action: StatusBarActions.Action): IStatus => {
  switch (action.type) {
    case StatusBarActions.Type.WEBSOCKET_CONNECTION_STATUS:
      return { ...state, isConnected: action.isConnected };
    default:
      return state;
  }
};
